import { LocationTypeEnum } from './location-type.enum';
import { Location } from './location';

export class LocationRequest {

    static fromLocation(location: Location): LocationRequest {

        const locationRequest = new LocationRequest();
        locationRequest.geometry = location.geometry;
        locationRequest.name = location.name;
        locationRequest.type = location.type;
        locationRequest.abbreviation = location.abbreviation;
        locationRequest.parentLocId = location.parentLocId;
        locationRequest.countryId = location.countryId;
        locationRequest.altitude = location.altitude;
        locationRequest.latitude = location.latitude;
        locationRequest.longitude = location.longitude;

        return locationRequest;
    }

    constructor(
        public geometry?: string,
        public name?: string,
        public type?: LocationTypeEnum,
        public abbreviation?: string,
        public parentLocId?: number,
        public countryId?: number,
        public altitude?: number,
        public latitude?: number,
        public longitude?: number
    ) {
    }

}
